import { repairOptionApiService } from '@/services/repairOption-api.service'
import { gadgetApiService } from '@/services/gadget-api.service'
import { claimsApiService } from '@/services/claims-api.service'
import { salesApiService } from '@/services/sales-api.service.js'

const setSelectedRROptionBER = async ({ commit, dispatch }, payload) => {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
        repairOptionApiService.setSelectedOptionBER(payload)
            .then((response) => {
                let { data, messages } = response.data
                if (data) {
                    dispatch('notificationModule/toast', 'Successfully set BER!')
                    resolve(data)
                } else {
                    if (messages != null && messages.length > 0) {
                        for (var i = 0; i < messages.length; i++) {
                            let msg = messages[i].body
                            dispatch('notificationModule/toast', msg)
                        }
                    }
                    if (reject)
                        reject(messages)
                }
            })
            .catch((error) => {
                dispatch('notificationModule/toast', `Error attemting to set BER! [${error}]`)
                if (reject)
                    reject(error)
            })
            .finally(() => { commit('setLoading', false) })
    })
}

const setSelectedRROptionQuoteOnly = async ({ commit, dispatch }, payload) => {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
        repairOptionApiService.setSelectedOptionQuoteOnly(payload)
            .then((response) => {
                let { data, messages } = response.data
                if (data) {
                    dispatch('notificationModule/toast', 'Successfully set Quote only!')
                    resolve(data)
                } else {
                    if (messages != null && messages.length > 0) {
                        for (var i = 0; i < messages.length; i++) {
                            let msg = messages[i].body
                            dispatch('notificationModule/toast', msg)
                        }
                    }
                    if (reject)
                        reject(messages)
                }
            })
            .catch((error) => {
                dispatch('notificationModule/toast', `Error attemting to set Quote only! [${error}]`)
                if (reject)
                    reject(error)
            })
            .finally(() => { commit('setLoading', false) })
    })
}

const setSelectedRROptionFaulty = async ({ commit, dispatch }, payload) => {
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
        repairOptionApiService.setSelectedOptionFaulty(payload)
            .then((response) => {
                let { data, messages } = response.data
                if (data) {
                    dispatch('notificationModule/toast', 'Successfully set Faulty!')
                    resolve(data)
                } else {
                    if (messages != null && messages.length > 0) {
                        for (var i = 0; i < messages.length; i++) {
                            let msg = messages[i].body
                            dispatch('notificationModule/toast', msg)
                        }
                    }
                    if (reject)
                        reject(messages)
                }
            })
            .catch((error) => {
                dispatch('notificationModule/toast', `Error attemting to set Faulty! [${error}]`)
                if (reject)
                    reject(error)
            })
            .finally(() => { commit('setLoading', false) })
    })
}

const setSelectedRROptionForGadget = ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
        repairOptionApiService
            .setSelectedOption(payload)
            .then((response) => {
                let { data, messages } = response.data
                if (messages && messages.length > 0) {
                    dispatch('notificationModule/toast', messages[0].body)
                } else {
                    dispatch('notificationModule/toast', 'Successfully set selected option')
                }
                resolve(response.data)
            })
            .catch((error) => {
                dispatch('notificationModule/toast', 'Failed to set selected option')
                if (reject) {
                    reject(error)
                }
            })
    })


}

const fetchOptionsPreviewForGadget = ({ commit, dispatch }, payload) => {    
    commit('setClaimGadgetOptionsPreview', null)
    return new Promise((resolve, reject) => {
        repairOptionApiService.previewOptionsForGadget(payload)
            .then((response) => {
                let { data, messages } = response.data
                commit('setClaimGadgetOptionsPreview', data)
                if (data == null) {
                    dispatch('notificationModule/toast', 'No options returned')
                } 
                resolve(response.data)
            })
            .catch((error) => {
                console.log('addDeveloperException', error)
                dispatch('notificationModule/toast', 'No options returned')
                if (reject) {
                    reject(error)
                }
            })
    })
}

const fetchSelectedOptionTasks = ({ commit, dispatch }, payload) => {
    commit('setLoading', true)
    commit('setSelectedClaim', null)
    commit('setClaimsList', null)
    //commit('setPagenation', null)
    return new Promise((resolve, reject) => {
        repairOptionApiService.getSelectedSettlementOptionTasks(payload)
            .then((response) => {
                let { data, pagination, messages } = response.data
                commit('setClaimsList', data)
                commit('setPagenation', pagination)
                resolve(response.data)
            })
            .catch((error) => {
                if (reject) {
                    reject(error)
                }
            })
            .finally(() => { commit('setLoading', false) })
    })
}

const fetchGadgetsForClaim = ({ commit }, payload) => {
    //commit('setLoading', true)
    gadgetApiService.getForClaim(payload)
        .then((response) => {
            let { data } = response.data
            commit('setClaimSelectedGadgetDetails', data)
        })
        .catch((error) => {
            commit('addDeveloperException', error)
        })
        .finally(() => { /*commit('setLoading', false)*/ })
}

const fetchTaskHistoryForClaim = ({ commit }, payload) => {
    claimsApiService.getTaskHistoryForClaim(payload)
        .then((response) => {
            let { data } = response.data
            commit('setClaimSelectedTaskHistory', data)
            console.log(data)
        })
        .catch((error) => {
            console.error(error)
        })
        .finally(() => { /*commit('setLoading', false)*/ })
}

const getSupplierImportRROptionStatusTypes = async ({ commit }) => {
    return repairOptionApiService.getSupplierImportRROptionStatusTypes()
        .then((response) => {
            //console.log('-r : ', response)
            return new Promise((resolve, reject) => {
                resolve(response.data)
            })
        })
        .catch((error) => {
            console.error(error)
        })
        .finally(() => { /**/ })
}

const getClaimsListPagenated = async ({ commit }, payload) => {
    commit('setLoading', true)
    commit('setSelectedClaim', null)
    commit('setClaimsList', null)
    try {
        const response = await claimsApiService.getClaimsFilterPagenated(payload)

        let { data, pagenation } = response.data
        commit('setClaimsList', data)
        commit('setPagenation', pagenation)

        return new Promise((resolve, reject) => {
            resolve({ data, pagination: pagenation })
        })

    } catch (error) {
        console.error(error)
    } finally { commit('setLoading', false) }
}

const getClaimsListPagenatedV2Async = async ({ commit }, payload) => {
    commit('setLoading', true)
    //commit('setSelectedClaim', null)
    //commit('setClaimsList', null)
    try {
        const response = await claimsApiService.getClaimsFilterPagenated(payload)

        let { data, pagenation } = response.data
        commit('setClaimsList', data)
        commit('setPagenation', pagenation)

        return new Promise((resolve, reject) => {
            resolve({ data, pagination: pagenation })
        })

    } catch (error) {
        console.error(error)
    } finally { commit('setLoading', false) }
}

const fetchExcessPaymentsClaim = async ({ commit }, payload) => {
    /*commit('setLoading', true)*/
    try {
        const response = await claimsApiService.getClaimsExcessCardPaymentsFilterPagenated(payload)
        let { data } = response.data
        commit('setClaimExcessPayments', data)
        return new Promise((resolve, reject) => {
            resolve({ data })
        })

    } catch (error) {
        console.error(error)
    } finally { /*commit('setLoading', false)*/ }
        
}

import axios from 'axios'

const fetchExcessCalculationsClaim = async ({ commit }, payload) => {
    /*commit('setLoading', true)*/
    try {
        const response = await axios.get('/api/admin/v1/claims/getexcesscalculations/' + payload)
        //console.log('-r: ', response)
        let { data } = response
        //console.log('-d: ', data)
        commit('setClaimExcessCalculations', data)
        return new Promise((resolve, reject) => {
            resolve({ data })
        })

    } catch (error) {
        console.error(error)
    } finally { /*commit('setLoading', false)*/ }

}

const fetchDocumentsClaim2 = async ({ commit }, payload) => {
    try {
        commit('setClaimDocumentsLoading', true)
        const response = await claimsApiService.getDocumentsForClaim(payload)
        let { data } = response.data
        commit('setClaimDocuments', data)
        commit('setClaimDocumentsLoading', false)
        return new Promise((resolve, reject) => {
            resolve({ data })
        })
    } catch (error) {
        console.error(error)
        commit('setClaimDocumentsLoading', false)
    }
}

const searchTigaQuote = async ({ commit }, payload) => {
    try {
        //commit('setClaimDocumentsLoading', true)
        const response = await salesApiService.tigaQuoteSearch(payload)
        let { data } = response.data
        //commit('setClaimDocuments', data)
        //commit('setClaimDocumentsLoading', false)
        return new Promise((resolve, reject) => {
            resolve({ data })
        })
    } catch (error) {
        console.error(error)
        //commit('setClaimDocumentsLoading', false)
    }
}

const resetPolicyTigaQuote = async ({ state, commit, dispatch }, payload) => {
    try {
        commit('setLoading', true)
        const response = await claimsApiService.resetPolicyTiga(payload)
        let { data, messages } = response.data
        let msg = 'Successfully reset Policy'
        if (messages != null && messages.length > 0) {
            msg = messages[0].body
        }
        dispatch('notificationModule/toast', msg)
        dispatch('fetchSelectedClaimEx', state.selectedClaim.claimId)
        commit('setLoading', false)
        return new Promise((resolve, reject) => {
            resolve({ data })
        })
    } catch (error) {
        console.error(error)
        commit('setLoading', false)
    }
}

const importPolicyClaim = async ({ state, commit, dispatch }, payload) => {
    commit('setLoading', true)
    let { insuranceLineId } = payload

    switch (insuranceLineId) {
        case 1:
            //claimsApiService.getGadgetPolicyForClaim(policyId)
            //    .then((response) => {
            //        let { data } = response.data
            //        commit('setClaimPolicy', data)
            //    })
            //    .catch((error) => {
            //        commit('addDeveloperException', error)
            //    })
            //    .finally(() => { commit('setLoading', false) })
            break;
        case 2:
            claimsApiService.importTigaPolicyForClaim(payload)
                .then((response) => {
                    let { data, messages } = response.data
                    commit('setClaimPolicy', data)
                    let msg = 'Successfully imported Policy'
                    if (messages != null && messages.length > 0) {
                        msg = messages[0].body
                    }
                    dispatch('notificationModule/toast', msg)

                    let { resellerId } = data
                    let { email } = state.selectedClaim.claimantDetails
                    dispatch('formUser/checkUserExists', { resellerId, emailAddress: email })

                    dispatch('fetchSelectedClaimEx', state.selectedClaim.claimId)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
            break;
        default:
        // code block
    }

}

const importPolicyClaim2 = async ({ state, commit, dispatch }, payload) => {
    commit('setLoading', true)
    let { insuranceLineId } = payload

    switch (insuranceLineId) {
        case 1:
            break;
        case 2:
        case 3:
            claimsApiService.importTigaPolicyForClaim2(payload)
                .then((response) => {
                    let { data, messages } = response.data
                    commit('setClaimPolicy', data)
                    let msg = 'Successfully imported Policy'
                    if (messages != null && messages.length > 0) {
                        msg = messages[0].body
                    }
                    dispatch('notificationModule/toast', msg)

                    let { resellerId } = data
                    let { email } = state.selectedClaim.claimantDetails
                    dispatch('formUser/checkUserExists', { resellerId, emailAddress: email })

                    dispatch('fetchSelectedClaimEx', state.selectedClaim.claimId)
                })
                .catch((error) => {
                    commit('addDeveloperException', error)
                })
                .finally(() => { commit('setLoading', false) })
            break;
        default:
        // code block
    }

}

export default {
    setSelectedRROptionBER,
    setSelectedRROptionForGadget,
    fetchOptionsPreviewForGadget,
    setSelectedRROptionQuoteOnly,
    setSelectedRROptionFaulty,
    fetchSelectedOptionTasks,
    fetchGadgetsForClaim,
    fetchTaskHistoryForClaim,
    getSupplierImportRROptionStatusTypes,
    getClaimsListPagenated,
    getClaimsListPagenatedV2Async,
    fetchExcessPaymentsClaim,
    fetchExcessCalculationsClaim,
    fetchDocumentsClaim2,
    searchTigaQuote,
    resetPolicyTigaQuote,
    importPolicyClaim,
    importPolicyClaim2
}